import { ExtensionTypeOption } from 'src/app/pages/extension-register/models/extension-type-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const extensionTypeOptionActions = createEagerSelectActions<ExtensionTypeOption>('[Extension Type Options]');
